<div class="main-content">
  <router-outlet></router-outlet>
</div>
<footer class="py-5">
  <div class="container">
    <div class="copyright text-center text-muted">
      &copy; {{ year | date: "yyyy" }} <a href="https://harryhallinsurance.com/" class="font-weight-bold ml-1" target="_blank">Harry Hall</a>
    </div>
  </div>
</footer>
